module.exports = __webpack_public_path__ + "img/member-reg.49fa4930.svg";